module.exports = __webpack_public_path__ + "img/kong-app.a4580bbb.png";